var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-form',{ref:"form",attrs:{"minContentHeight":350,"url":_vm.url,"form":_vm.form,"editingItem":_vm.user,"showCancel":"","id":"dialog-form"},on:{"saved":_vm.onSaved,"cancel":_vm.onCancel,"change":_vm.onChange,"itemChange":function($event){_vm.item = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }